import { t } from "i18next";
import { useContext, useEffect, useState } from "react";
import { Button, Col, Form, Modal, Row } from "react-bootstrap";
import { UserContext } from "../../../../App";
import { LoadingSpinner } from "../../../general/loading-spinner";
import { getCoachPlanningResults, updateCoachPlanningResults } from "../../../../services/planning";

interface CoachTrainingResultsProps {
    event: any;
    onClose: CallableFunction;
}

export function CoachTrainingResults(props: CoachTrainingResultsProps) {
    const { userProfile } = useContext(UserContext);

    const [loaded, setLoaded] = useState(false);
    const [trainingresultsData, setTrainingResultsData] = useState<any>();
    const [fatigueLevel, setFatigueLevel] = useState(0);

    useEffect(() => {
        getCoachPlanningResults(props.event.team_id, props.event.datetime.substr(0, 10), props.event.day_moment, props.event.day_moment_session)
            .then(response => {
                setTrainingResultsData(response.data);
                setFatigueLevel(response.data.fatigue_level);
                setLoaded(true);
            });
    }, []);

    const handleSave = (event: any) => {
        event.preventDefault();

        const body = {
            id: event.target.id.value,
            team_id: props.event.team_id,
            day: props.event.datetime.substr(0, 10),
            day_moment: props.event.day_moment,
            day_moment_session: props.event.day_moment_session,
            duration: event.target.duration.value,
            speed_avg: event.target.speed_avg.value,
            speed_max: event.target.speed_max.value,
            temperature: event.target.temperature.value,
            wind_speed: event.target.wind_speed.value,
            wind_direction: event.target.wind_direction.value,
            observations: event.target.observations.value
        }
        updateCoachPlanningResults(body)
            .then(response => {
                if (response.data.status == 1) {
                    props.onClose();
                } else {
                    alert(response.data.message);
                }
            })
            .catch(error => {
                console.log(error);
            });
    }

    const handleClose = () => {
        props.onClose();
    }

    return (<Modal className="set-training-results-container" show={ true }
        onHide={ handleClose } size="lg"> 
        <Modal.Header closeButton>
            <Modal.Title>
                { t("Training session results") }
            </Modal.Title>
        </Modal.Header>
        <Modal.Body>
            { !loaded && <LoadingSpinner /> }
            { loaded &&
                <Form onSubmit={ handleSave }>
                    <div className="fields">
                        <Form.Group controlId="id">
                            <Form.Control type="hidden" name="day" required 
                                defaultValue={ trainingresultsData?.id } />
                        </Form.Group>
                        <Row>
                            <Col lg={ 4 }>
                                <Form.Group className="mb-3" controlId="duration">
                                    <Form.Label>{ t("Duration") }</Form.Label>
                                    <Form.Control type="number" step="0.01" name="duration" defaultValue={ trainingresultsData.duration } />
                                </Form.Group>
                            </Col>
                            <Col lg={ 4 }>
                                <Form.Group className="mb-3" controlId="speed_avg">
                                    <Form.Label>{ t("Avg speed") }</Form.Label>
                                    <Form.Control type="number" step="0.01" name="speed_avg" defaultValue={ trainingresultsData.speed_avg } />
                                </Form.Group>
                            </Col>
                            <Col lg={ 4 }>
                                <Form.Group className="mb-3" controlId="speed_max">
                                    <Form.Label>{ t("Max speed") }</Form.Label>
                                    <Form.Control type="number" step="0.01" name="speed_max" defaultValue={ trainingresultsData.speed_max } />
                                </Form.Group>
                            </Col>
                            <Col lg={ 4 }>
                                <Form.Group className="mb-3" controlId="temperature">
                                    <Form.Label>{ t("Temperature") }</Form.Label>
                                    <Form.Control type="number" step="0.01" name="temperature" defaultValue={ trainingresultsData.temperature } />
                                </Form.Group>
                            </Col>
                            <Col lg={ 4 }>
                                <Form.Group className="mb-3" controlId="wind_speed">
                                    <Form.Label>{ t("Wind speed") }</Form.Label>
                                    <Form.Control type="number" step="0.01" name="wind_speed" defaultValue={ trainingresultsData.wind_speed } />
                                </Form.Group>
                            </Col>
                            <Col lg={ 4 }>
                                <Form.Group className="mb-3" controlId="wind_direction">
                                    <Form.Label>{ t("Wind direction") }</Form.Label>
                                    <Form.Control type="text" name="wind_direction" defaultValue={ trainingresultsData.wind_direction } />
                                </Form.Group>
                            </Col>
                            <Form.Group className="mb-3" controlId="observations">
                                <Form.Label>{ t("Observations") }</Form.Label>
                                <Form.Control name="observations" as="textarea"
                                    defaultValue={ trainingresultsData?.observations } />
                            </Form.Group>
                        </Row>
                    </div>
                    <div className="actions">
                        <Button type="submit" variant="primary">
                            { t("Save") }
                        </Button>
                        <Button variant="secondary" onClick={ handleClose }>
                            { t("Close") }
                        </Button>
                    </div>
                </Form>
            } 
        </Modal.Body>
    </Modal>);
}
